<!-- 3D Iframe -->
<template>
  <div v-loading="loading" class="iframe-3d quote-container__content">
    <iframe id="iframe3d" :src="iframeSrc" width="410" height="400" allowfullscreen="true"></iframe>
  </div>
</template>

<script>
import { HQPCB_HOST } from '@@/api/pcb'

// 阻焊颜色
const COLOR_MAP = {
  '绿色': 'green',
  '蓝色': 'blue',
  '黑色': 'black',
  '红色': 'red',
  '黄色': 'yellow',
  '白色': 'white',
  '哑光黑油': 'black'
}
// 表面处理
const PAD_MAP = {
  '有铅喷锡': 'tin',
  '无铅喷锡': 'tin',
  '沉金': 'gold',
  'OSP': 'OSP',
}

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    analyzeId: {
      type: String,
      default: ''
    },
    analyzeKey: {
      type: [String, Number],
      default: 0
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      iframe3d: null,
      iframeUrlParams: {}
    }
  },
  computed: {
    iframeParams() {
      const { type, height, color, pad } = this.params
      return {
        type: type || 'FR-4',
        height: height || '',
        pad: PAD_MAP[pad] || '',
        color: COLOR_MAP[color] || '',
      }
    },
    iframeSrc() {
      const { analyzeId, analyzeKey, iframeParams, iframeUrlParams } = this
      // url只带初始化时的参数
      if (!iframeUrlParams[analyzeId]) {
        iframeUrlParams[analyzeId] = Object.entries(iframeParams).map(([key, value]) => `&${key}=${value}`).join('')
      }

      // return `http://localhost:5173/iframeviewer?analyzeId=${analyzeId}&key=${analyzeKey}${iframeUrlParams[analyzeId] || ''}`
      return `${HQPCB_HOST}/gerberviewer/iframeviewer?id=${analyzeId}&key=${analyzeKey}${iframeUrlParams[analyzeId] || ''}`
    }
  },
  watch: {
    params(newVal) {
      this.handleParamsChange()
    }
  },
  mounted() {
    this.iframe3d = document.getElementById('iframe3d')
  },
  methods: {
    handleParamsChange() {
      if (this.iframe3d) {
        this.iframe3d.contentWindow.postMessage({ 
          name: 'switchPcbColor', 
          ...this.iframeParams
        }, HQPCB_HOST)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.iframe-3d {
  box-sizing: border-box;
  margin-left: 10px;
  padding: 0;
  width: 410px;
  height: 400px;
  overflow: hidden;
}
</style>